import { render, staticRenderFns } from "./activityResultApp.vue?vue&type=template&id=58f3ca86&scoped=true"
import script from "./activityResultApp.vue?vue&type=script&lang=js"
export * from "./activityResultApp.vue?vue&type=script&lang=js"
import style0 from "./activityResultApp.vue?vue&type=style&index=0&id=58f3ca86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f3ca86",
  null
  
)

export default component.exports